import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Sidebar.css';

function Sidebar() {
  const location = useLocation();
  const { logout, user } = useAuth();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div className="sidebar">
      {/* Logo Section */}
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <img src="/rate-logo.png" alt="Rate Logo" className="logo-img" />
        </div>
        <div className="sidebar-brand">
          <h2>Rate Intelligence</h2>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="sidebar-nav">
        <Link 
          to="/" 
          className={`sidebar-nav-item ${isActive('/') ? 'active' : ''}`}
        >
          <i className="fas fa-home"></i>
          <span>Home</span>
        </Link>

        <div className="sidebar-section-title">Insurance</div>
        <Link 
          to="/insurance/upload" 
          className={`sidebar-nav-item ${isActive('/insurance/upload') ? 'active' : ''}`}
        >
          <i className="fas fa-shield-alt"></i>
          <span>Upload Insurance</span>
        </Link>

        <Link 
          to="/insurance/monitor" 
          className={`sidebar-nav-item ${isActive('/insurance/monitor') ? 'active' : ''}`}
        >
          <i className="fas fa-desktop"></i>
          <span>Insurance Monitor</span>
        </Link>

        <div className="sidebar-section-title">Title</div>
        <Link 
          to="/title/upload" 
          className={`sidebar-nav-item ${isActive('/title/upload') ? 'active' : ''}`}
        >
          <i className="fas fa-file-contract"></i>
          <span>Upload Title</span>
        </Link>

        <Link 
          to="/title/monitor" 
          className={`sidebar-nav-item ${isActive('/title/monitor') ? 'active' : ''}`}
        >
          <i className="fas fa-chart-line"></i>
          <span>Title Monitor</span>
        </Link>

        <div className="sidebar-section-title">Search</div>
        <Link 
          to="/search" 
          className={`sidebar-nav-item ${isActive('/search') ? 'active' : ''}`}
        >
          <i className="fas fa-search"></i>
          <span>Custom Search</span>
          <span className="badge-coming-soon">Coming Soon</span>
        </Link>

        <div className="sidebar-section-title">AI Assistant</div>
        <Link 
          to="/chatbot" 
          className={`sidebar-nav-item ${isActive('/chatbot') ? 'active' : ''}`}
        >
          <i className="fas fa-comments"></i>
          <span>AI Chat</span>
          <span className="badge-new">AI</span>
        </Link>

        <div className="sidebar-section-title">Custom</div>
        <Link 
          to="/custom-processor" 
          className={`sidebar-nav-item ${isActive('/custom-processor') ? 'active' : ''}`}
        >
          <i className="fas fa-magic"></i>
          <span>Custom Processor</span>
          <span className="badge-coming-soon">Coming Soon</span>
        </Link>
      </nav>

      {/* Footer - User Section */}
      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="user-avatar">
            <i className="fas fa-user"></i>
          </div>
          <div className="user-info">
            <div className="user-name">{user?.email || user?.name || 'User'}</div>
            <div className="user-role">{user?.email ? 'Authenticated' : 'Administrator'}</div>
          </div>
        </div>
        <button 
          className="logout-btn" 
          title="Logout"
          onClick={handleLogout}
        >
          <i className="fas fa-sign-out-alt"></i>
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
